import { TypeCurveScalingBase } from './base/type-curve-scaling-base';

export class TypeCurveScaling extends TypeCurveScalingBase { }